import { useQuery } from '@tanstack/react-query';
import { listVersions } from './connectorsApi';

export const useGetVersionsHandler = (connectorKey) => {
  const query = useQuery({
    queryKey: ['connector-versions', connectorKey],
    queryFn: () => listVersions(connectorKey),
    enabled: Boolean(connectorKey),
  });

  return {
    versions: query.data || [],
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
};
